import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Application } from '@enums/application.enums';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchBarV2Component {
  @Output() handleSearch = new EventEmitter<string>();
  @Input() placeholder: string = Application.SEARCH_BY_REQUESTED_FROM;
  timeout: NodeJS.Timeout | undefined;

  searchObj = { text: '' };

  searchEvent(event: any) {
    this.searchObj.text = event?.target.value;
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      this.handleSearch.emit(event?.target.value);
    }, Application.FIVE_HUNDRED);
  }

  clearSearch() {
    this.searchObj.text = '';
    this.handleSearch.emit('');
  }
}
